import { createFileRoute } from "@tanstack/react-router";
import { ExpenseDashboard } from "@/components/portal/apps/expense/ExpenseDashboard";

export const Route = createFileRoute("/portal/apps/expense")({
  component: PortalExpensePage,
});

function PortalExpensePage() {
  return <ExpenseDashboard />;
}
